// apps/web-investor route table (Phase C — investor surface).
//
//   /            → InvestorDashboard (§5.6.1) — the investor home
//   /canvas      → Canvas (§5.6.2) — the v6-equivalent 3-pane surface
//   /chat        → Chat (K.4) — chat-primary surface; sibling of /canvas
//   /subscribe/:subscriptionId/:step
//                → Subscribe (§2.3) — 5-step subscription flow spine.
//   /profile     → Profile
//   /debug/*     → dev-only routes (VITE_SHOW_DEV_ROUTES)

import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter([
  {
    path: '/',
    lazy: async () => {
      const { Layout } = await import('./routes/Layout');
      return { Component: Layout };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const { InvestorDashboard } = await import('./routes/InvestorDashboard');
          return { Component: InvestorDashboard };
        },
      },
      {
        path: 'canvas',
        lazy: async () => {
          const { Canvas } = await import('./routes/Canvas');
          return { Component: Canvas };
        },
      },
      {
        path: 'chat',
        lazy: async () => {
          const { Chat } = await import('./routes/Chat');
          return { Component: Chat };
        },
      },
      {
        path: 'subscribe/:subscriptionId/:step',
        lazy: async () => {
          const { Subscribe } = await import('./routes/Subscribe');
          return { Component: Subscribe };
        },
      },
      {
        path: 'profile',
        lazy: async () => {
          const { Profile } = await import('./routes/Profile');
          return { Component: Profile };
        },
      },
      ...(import.meta.env.VITE_SHOW_DEV_ROUTES === 'true'
        ? [
            {
              path: 'debug/widgets',
              lazy: async () => {
                const { WidgetsDemo } = await import('./routes/WidgetsDemo');
                return { Component: WidgetsDemo };
              },
            },
            {
              path: 'debug/design-system',
              lazy: async () => {
                const { DebugDesignSystem } = await import('./routes/DebugDesignSystem');
                return { Component: DebugDesignSystem };
              },
            },
          ]
        : []),
    ],
  },
]);
